/**
 * Drizzle queries (PowerSync local-first) for the SUPERVISION domain.
 *
 * Local mirror synchronizes `supervised_profile` + `usage_event` (streams
 * `my_supervision`/`org_supervision`). Guardian panel reads from here;
 * aggregated telemetry report is requested via API (sealing the view in
 * guardian audit log).
 */

import { and, count, desc, eq, isNull } from "drizzle-orm";
import { type PowerSyncDrizzleDB, supervised_profile } from "@custodia/powersync";

/** Active supervised profiles (not deleted), most recent first. */
export function getSupervisedProfilesQuery(db: PowerSyncDrizzleDB) {
  return db
    .select()
    .from(supervised_profile)
    .where(isNull(supervised_profile.deleted_at))
    .orderBy(desc(supervised_profile.created_at));
}

/** Specific profile (for details view). */
export function getSupervisedProfileQuery(db: PowerSyncDrizzleDB, id: string) {
  return db
    .select()
    .from(supervised_profile)
    .where(and(eq(supervised_profile.id, id), isNull(supervised_profile.deleted_at)));
}

/**
 * Number of active profiles for a user. Used by login flow to determine
 * whether a guest has local data to offer merging (keep/discard).
 */
export function getSupervisedProfileCountForUserQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ total: count(supervised_profile.id).mapWith(Number) })
    .from(supervised_profile)
    .where(and(eq(supervised_profile.user_id, userId), isNull(supervised_profile.deleted_at)));
}
